var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CheckIcon from '@mui/icons-material/Check';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { logger, handleExport, customBodyForExcelReport, checkAuthentication,muiLoaderOptions } from '../../utils';
import POBreakdown from './POBreakdown';
import POInvoiceBreakdown from './POInvoiceBreakdown'
const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));

export default function ReportBilledPO() {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const classes = pageStyles();

    const getData = async () => {
        await fetch('/api/PO', {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
					setDataSet(json);
					setIsLoading(false);
				})

    };

    const columns = [
        {
            name: "Time Billed",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div style={{ display: "flex" }}>
                            <POBreakdown data={dataSet[dataIndex]} />
                        </div>
                    );
                }

            }
        },
        {
            name: "Billed Invoice",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div style={{ display: "flex" }}>
                            <POInvoiceBreakdown data={dataSet[dataIndex]} />
                        </div>
                    );
                }

            }
        }, 
        {
            name: "PoNumber",
            label: "PO number",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "CommonName",
            label: "PO Short Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "StartDate",
            label: "Start Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].StartDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "EndDate",
            label: "End Date",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].EndDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "Amount",
            label: "Amount",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        parseFloat(dataSet[dataIndex].Amount).toFixed(2)
                    );
                }
            }
        },
        {
            name: "NumInvoice",
            label: "# of Invoices",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "InvoiceTotal",
            label: "Invoice Sum",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        parseFloat(dataSet[dataIndex].InvoiceTotal).toFixed(2)
                    );
                }
            }
        },
        {
            name: "remainder",
            label: "Remainder",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        parseFloat(dataSet[dataIndex].remainder).toFixed(2)
                    );
                }
            }
        },
          {
            name: "IsActive",
            options: {
                filter: true,
                sort: true,
                empty: true,
                filterList: [1],
                customFilterListOptions:
                {
                    render: v => {
                        if (v === 0) {
                            return "Show InActive";
                        }
                        if (v === 1) {
                            return "Show Active";
                        }
                        return val;
                    },
                },
                filterOptions: {
                    renderValue: val => {
                        if (val === 0) {
                            return "InActive";
                        }
                        if (val === 1) {
                            return "Active";
                        }
                        return val;
                    }
                }, 
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div className={classes.root}> 
                            {(dataSet[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}
                         
                        </div>
                    );
                }

            }
        },
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        responsive: 'standard',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
		    toolbar: {
		      search: "Search",
		      downloadCsv: "Download Excel", 
		      print: "Print",
		      viewColumns: "View Columns",
		      filterTable: "Filter Table",
		    	},
		},
        selectableRows: 'none',
        onDownload: (buildHead, buildBody, columns, data) => {
            // Custom buildHead and buildBody functions
            const customBuildHead = () => {
                var newColumns = columns.map(column => column.label);
                return newColumns;
            }

            const customBuildBody = () => {
                const headers = customBuildHead();
                data.map((value, index) => {
                    logger(`map${index}`, value)
                    var eachRow = value

                    eachRow.data[4] = moment.utc(eachRow.data[4]).format('MM/DD/YYYY')
                    eachRow.data[5] = moment.utc(eachRow.data[5]).format('MM/DD/YYYY')

                })
                return customBodyForExcelReport({ data: data, headers: headers });
            };

            const headers = customBuildHead();
            const rows = customBuildBody();
            handleExport({ rows: rows, headers: headers, filename: 'ReportBilledPO.xlsx' })
            return false;
        }

    };
    
    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        if (refresh) {

            getData()
            setRefresh(false);
        }

    })

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div className={classes.root}>
            <Button className={classes.root} variant="contained" onClick={handleClickOpen}>
                Report Billed PO
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                    <DialogContent >
                        <Box>						
                            <MUIDataTable className={classes.root}
                                title={

                                    <Typography variant="h6" style={{ color: "white" }}>
                                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
                                        Report Billed PO
                                    </Typography>
                                }
                                data={isLoading ? [] :dataSet}
                                columns={columns}
                                options={muiLoaderOptions(options, isLoading)}
                            />
                           </Box>
                    </DialogContent>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}

 